// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"unFunctionalPage_subtitle__1TEax","pLine":"unFunctionalPage_pLine__1Z0Go"};